export const notifActions = (state, dispatch, props) => {
  function updateNotif(notifData) {
    dispatch({ type: "NOTIF_UPDATE", payload: notifData });
  }

  return {
    updateNotif,
  };
};
